<h2 mat-dialog-title>
  {{ 'PREVIEW_EMAIL_DIALOG.PREVIEWING_EMAIL' | translate }}
</h2>
<mat-dialog-content class="preview-email-container">
  <div class="preview-email-subject">
    <span [innerHtml]="'PREVIEW_EMAIL_DIALOG.SUBJECT' | translate"></span>
  </div>
  <div>
    <img
      src="https://vstatic-prod.apigateway.co/partner-center-client.9223372035141236080.prod/assets/images/product-activated-email.png"
      [alt]="'PREVIEW_EMAIL_DIALOG.PRODUCT_ACTIVATED_EMAIL' | translate"
      height="380"
    />
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="dialogRef.close()">
    {{ 'COMMON.ACTION_LABELS.CLOSE' | translate }}
  </button>
</mat-dialog-actions>
